import {Directive, ElementRef, HostListener, Optional} from '@angular/core';
import {KeyboardService} from "@app/services/keyboard.service";
import {NgControl} from "@angular/forms";
import {IUserAssign} from "@app/interfaces/i-user";
import {Repository} from "@clavisco/core";
import {ICurrentSession} from "@app/interfaces/i-localStorage";
import {StorageKey} from "@app/enums/e-storage-keys";

@Directive({
  selector: 'input[appKeyboardInput], textarea[appKeyboardInput]'
})
export class KeybordInputDirective {

  currentUser: IUserAssign = Repository.Behavior.GetStorageObject<IUserAssign>(StorageKey.CurrentUserAssign) as IUserAssign;
  constructor(
    private el: ElementRef,
    private keyboardService: KeyboardService,
    @Optional() private ngControl: NgControl
  ) {}

  /**
   * Handles the focus event on the input or textarea.
   * Activates the virtual keyboard unless the field is read-only.
   * @param event Focus event triggered on the element.
   */
  @HostListener('focus', ['$event'])
  onFocus(event: FocusEvent) {
    const element = event.target as HTMLInputElement | HTMLTextAreaElement;

    //Validates whether the field is read-only to not display the keyboard or if the keyboard is disabled.
    if(element.readOnly || !this.currentUser.ShowKeyboard) return;

    this.keyboardService.SetActiveInput({
      Element: element,
      Control: this.ngControl?.control,
    });
  }

  /**
   * Handles the focusout event on the input or textarea.
   * Clears the active input unless another keyboard input is focused.
   * @param event Focus event triggered on the element.
   */
  @HostListener('focusout', ['$event'])
  onFocusOut(event: FocusEvent) {
    // Check if the new focused element is another input of ours
    const relatedTarget = event.relatedTarget as HTMLElement;
    const isKeyboardInput = relatedTarget?.hasAttribute('appKeyboardInput');

    //the event is delayed so that it does not overlap with others
    setTimeout(() =>{
      if (!this.el.nativeElement.contains(document.activeElement)) {

        // Trigger change event manually on exit
        const changeEvent = new Event('change', { bubbles: true });
        this.el.nativeElement.dispatchEvent(changeEvent);
      }
        this.keyboardService.ClearActiveInput(isKeyboardInput ? relatedTarget : undefined)
    },200);
  }

  /**
   * Handles the keyup event on the input or textarea.
   * Updates the cursor position in the virtual keyboard.
   */
  @HostListener('keyup', ['$event'])
  onKeyUp() {
    this.keyboardService.UpdateCursorPosition(
      this.el.nativeElement
    );
  }

  ngOnDestroy() {
    this.keyboardService.ClearActiveInput();
  }

}
